/**
 * Unpin Tool - Unpins selected elements
 */
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';

export class UnpinTool extends BaseTool {
    id = 'UNPIN';
    name = 'Unpin';
    cursor = 'default';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        const selection = this.context?.appStore.selectedIds || [];
        if (selection.length > 0) {
            this.unpinElements(selection);
        } else {
            const id = this.findElementIdAtPoint(event);
            if (id) {
                this.unpinElements([id]);
            }
        }
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    private unpinElements(ids: string[]) {
        if (!this.context) return;
        ids.forEach(id => {
            const el = this.context!.bimStore.project.elements.get(id);
            if (el) {
                // Update 'Pinned' parameter to false
                // Also remove 'PINNED' constraint if it exists in constraint list?
                // For now, simpler parameter approach:
                const newParams = { ...el.parameters, 'Pinned': false };
                this.context!.bimStore.updateElement(id, { parameters: newParams });

                // Also remove constraint if we used that system
                // const newConstraints = el.constraints?.filter(c => c.type !== 'PINNED');
                // this.context!.bimStore.updateElement(id, { constraints: newConstraints });
            }
        });
        console.log('Unpinned elements:', ids);
    }

    onPointerMove(): void { }
    onPointerUp(): void { }
}
